import { Center, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"

// `next/error` is a Pages Router component and does not work in the App Router.
export function Page404() {
  const { t } = useTranslation()
  return (
    <Center h="50vh" p="xl">
      <Text c="dimmed" fz="xl" fw={500} ta="center">
        {t("Page not found")}
      </Text>
    </Center>
  )
}
